import urls from "./schemas/index-es";
import { methods, keyWords, preserveKeyWords } from "./constants-es";
import { transposers } from "./transposers-es";
const deconstructLevel = (level, data = {}) => {
  // if passed value is a string, then it is the path
  if (typeof level === "string") return { path: level };

  return Object.keys(level).reduce((acc, key) => {
    if (preserveKeyWords.includes(key)) {
      // preserved keys words are transposed as is
      switch (key) {
        case "methods":
          acc.methods = [...(acc.methods || []), ...level[key]];
          break;
        case "path":
          acc.path = level[key];
          break;
        default:
          break;
      }
    } else if (keyWords.includes(key) || transposers[key]) {
      // if the key is a reserved keyword
      if (methods.includes(key)) {
        // if the key is a method type
        data.methods = [...(data.methods || []), key];
        acc = { ...acc, ...deconstructLevel(level[key], { ...data }) };
        // } else if (transposers[key]) {
        //   // if the key is a path transposer
        //   console.log({ transposers: key })
        //   acc = { ...acc, ...deconstructLevel(level[key], { ...data, [key]: true }) }
      } else {
        // if the key is a NOT method type
        acc = {
          ...acc,
          ...deconstructLevel(level[key], { ...data, [key]: true }),
        };
      }
    } else if (typeof level[key] === "string") {
      // the key must be the indentier
      // if the value is a string, then it is the path, so close the loop
      acc[key] = {
        ...data,
        path: level[key],
      };
    } else {
      // the key must be the indentier
      // record the identifier, but continue to destructure the values
      acc[key] = { ...data, ...deconstructLevel(level[key], { ...data }) };
    }
    return acc;
  }, {});
};
const populated = Object.keys(urls).reduce((acc, controller) => {
  acc[controller] = deconstructLevel(urls[controller]);
  return acc;
}, {});

export default populated;
